
export const
  // ...?io-key=true&kiosk=blarg becomes:
  // { "io-key": "true", "kiosk": "blarg" }
  queryStringAsObject = () => Object.fromEntries(new URLSearchParams(window.location.search)),

  // returns true if the given option is present and set to "true", case-insensitive
  queryStringOptionTrue = qsOptionName =>
    queryStringAsObject()[qsOptionName]?.toLowerCase() === "true"

  // we only needed "true" comparison when this was created
  // make more high-level query-string methods as needed

export default { queryStringOptionTrue }
